export var MaintenanceRunType;
(function (MaintenanceRunType) {
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_UNSPECIFIED"] = "MAINTENANCE_RUN_TYPE_UNSPECIFIED";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_COMPACTION"] = "COMPACTION";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_EXPIRE_SNAPSHOTS"] = "EXPIRE_SNAPSHOTS";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_REMOVE_ORPHAN_FILES"] = "REMOVE_ORPHAN_FILES";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_PAIMON_COMPACTION"] = "PAIMON_COMPACTION";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_PAIMON_EXPIRE_SNAPSHOTS"] = "PAIMON_EXPIRE_SNAPSHOTS";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_PAIMON_REMOVE_ORPHAN_FILES"] = "PAIMON_REMOVE_ORPHAN_FILES";
    MaintenanceRunType["MAINTENANCE_RUN_TYPE_PAIMON_MANIFEST_COMPACTION"] = "PAIMON_MANIFEST_COMPACTION";
})(MaintenanceRunType || (MaintenanceRunType = {}));
